module.exports = __webpack_public_path__ + "3bfd621f94ce7dcc5bdd7f5247229edc.MP3";